import { render, staticRenderFns } from "./Ratificacao.vue?vue&type=template&id=adc9c522&"
import script from "./Ratificacao.vue?vue&type=script&lang=js&"
export * from "./Ratificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports